export const marital = [
  'Solteiro',
  'Casado',
  'Viúvo',
  'Divorciado',
  'Convivente',
  'Separado',
];
